export const NavbarLinks = [
  {
    id: '1',
    title: 'Home',
    path: '/'
  },
  {
    id: '2',
    title: 'Catalog'
    // path: '/catalog',
  },
  {
    id: '3',
    title: 'Contact Us',
    path: '/contact'
  }
];
